import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./outline/forecast-upgrade.svg";
var ForecastUpgradeOutline_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  ForecastUpgradeOutline_default as default
};
